import api from "@/lib/axios";

export const emailService = {
  /** Applications table: direct email via sendMail-candidate */
  sendEmailToCandidates: async (emailData) => {
    try {
      const payload = {
        subject: emailData.subject,
        body: emailData.body,
      };

      if (emailData.application_ids?.length) {
        payload.application_ids = emailData.application_ids;
      } else if (emailData.candidate_ids?.length) {
        payload.candidate_ids = emailData.candidate_ids;
      }

      const response = await api.post("/sendMail-candidate", payload);
      return response.data;
    } catch (error) {
      throw new Error(
        "Failed to send email: " +
          (error.response?.data?.message || error.message),
      );
    }
  },

  /** Unified newsletter send for marketing Email + SMS */
  sendNewsletter: async (data) => {
    try {
      const payload = {
        channel: data.channel,
        candidates: data.candidates,
      };

      if (data.template_id) {
        payload.template_id = data.template_id;
      }

      if (data.campaign_id) {
        payload.campaign_id = data.campaign_id;
      }

      if (data.campaign_name) {
        payload.campaign_name = data.campaign_name;
      }

      if (data.channel === "email") {
        payload.subject = data.subject;
        payload.body = data.body;
      }

      if (data.channel === "sms") {
        payload.sms_body = data.sms_body;
      }

      const response = await api.post("/newsletter/send", payload);
      return response.data;
    } catch (error) {
      throw new Error(
        error.response?.data?.message ||
          error.message ||
          `Failed to send ${data.channel === "sms" ? "SMS" : "email"}`,
      );
    }
  },
};
